(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("window"));
	else if(typeof define === 'function' && define.amd)
		define(["window"], factory);
	else if(typeof exports === 'object')
		exports["Mashlib"] = factory(require("window"));
	else
		root["Mashlib"] = factory(root["window"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__8392__) => {
return 